/**
 * Помощники для просмотра документа во встроенном браузерном вьювере (новая вкладка).
 * Вкладку открываем синхронно на клике (popup-safe), сразу рисуем спиннер, а когда придёт
 * файл — навигируем на blob-URL. Спиннер устраняет «пустой белый экран» во время генерации/загрузки.
 */

const LOADING_HTML = `<!doctype html>
<html lang="ru"><head><meta charset="utf-8"><title>Предпросмотр документа</title>
<style>
  html,body{height:100%;margin:0;background:#fafafa}
  .wrap{height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;
    font-family:Roboto,Arial,sans-serif;color:#616161}
  .spinner{width:48px;height:48px;border:4px solid #e0e0e0;border-top-color:#1976d2;
    border-radius:50%;animation:spin 1s linear infinite}
  @keyframes spin{to{transform:rotate(360deg)}}
  .txt{margin-top:16px;font-size:15px}
</style></head>
<body><div class="wrap"><div class="spinner"></div><div class="txt">Готовим документ…</div></div></body></html>`;

// Экранируем message: это единственная интерполируемая часть — даже если сюда придёт
// серверная строка, она не должна выполниться как разметка (защита от XSS в новой вкладке).
function escapeHtml(s: string): string {
  const map: Record<string, string> = {
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  };
  return s.replace(/[&<>"']/g, (c) => map[c]);
}

const errorHtml = (message: string): string => `<!doctype html>
<html lang="ru"><head><meta charset="utf-8"><title>Ошибка</title>
<style>
  html,body{height:100%;margin:0;background:#fafafa}
  .wrap{height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;
    font-family:Roboto,Arial,sans-serif;color:#c62828;text-align:center;padding:0 24px}
  .txt{margin-top:12px;font-size:16px}
</style></head>
<body><div class="wrap"><div style="font-size:48px">&#9888;</div><div class="txt">${escapeHtml(message)}</div></div></body></html>`;

function writeTab(tab: Window | null, html: string): void {
  if (!tab) return;
  try {
    tab.document.open();
    tab.document.write(html);
    tab.document.close();
  } catch (e) {
    // вкладка могла быть закрыта пользователем — игнорируем
  }
}

/** Открыть пустую вкладку (синхронно, в обработчике клика) и нарисовать спиннер. */
export function openLoadingTab(): Window | null {
  const tab = window.open('', '_blank');
  writeTab(tab, LOADING_HTML);
  return tab;
}

/** Показать ошибку в уже открытой вкладке (вместо того чтобы её закрывать/оставлять пустой). */
export function showTabError(tab: Window | null, message = 'Не удалось загрузить документ'): void {
  writeTab(tab, errorHtml(message));
}
